import React from "react";
import {Navigate, Route, Routes} from "react-router-dom";
import authList from "./authList";
import {useSelector} from "react-redux";
import {selectFilterAuthRoute} from "../reducer/route/routeSlice";

const AuthRoute: React.FC<{logout: () => void, user?: any}> = ({logout, user}) => {

    const authListRoute = useSelector(selectFilterAuthRoute);
    return (<>
        {authListRoute &&
            <Routes>
                {authListRoute.list.map(route => <Route
                    key={route.path}
                    path={route.path}
                    element={route.component}
                />)}
                {authList.redirect && <Route path="*" element={<Navigate to={authList.redirect} />} />}
            </Routes>
        }
        {/*<Header logout={logout} user={user}  />*/}

    </>)
}

export default AuthRoute;
